// Module
var code = "<td ng-if=\"state == 'noData'\" colspan=\"{{colspan}}\">{{'main.ZIADNE_UDAJE' | translate}}</td> <td ng-if=\"state == 'loading'\" colspan=\"{{colspan}}\" class=\"info\"> <i class=\"fa fa-spinner fa-spin\"></i> {{'main.LOADING_DATA' | translate}} </td> ";
// Exports
module.exports = code;